import React from 'react'
import { Link as InternalLink } from "gatsby"

export const LINK_TYPES = {
	INTERNAL: "internal",
	EXTERNAL: "external",
	DOWNLOAD: "download"
}

export const isInternal = (url) => {
	// check against regex
	return /^\/(?!\/)/.test(url)
}

export const tidyURL = (url) => {
	// remove this domain
	return url.replace(process.env.URL,'');
}

export const standardiseInternalURL = (url) => {
	return url.replace(/\/?(\?|#|$)/, '/$1').toLowerCase();
}

export const getLinkPropsFromURL = (url) => {
	if(url){
		url = tidyURL(url);
		if(isInternal(url)){
			url = standardiseInternalURL(url);
			return {
				as:InternalLink,
				to:url,
				type: LINK_TYPES.INTERNAL
			}
		}

		return {
			as:"a",
			href:url,
			type: LINK_TYPES.EXTERNAL
		}
	}

	return {};
};

export const getLinkPropsFromMeta = (meta) => {
	return {
		as:InternalLink,
		to:getPathFromMeta(meta)
	}
}

export const getLinkPropsFromReference = (reference) => {
	if(reference){
		switch(reference._linkType){
			case 'Link.document':
				if(reference._meta){
					return getLinkPropsFromMeta(reference._meta)
				}
			break;
			case 'Link.web':
			case 'Link.image':
			case 'Link.media':
				if(reference.url){
					return {
						as:"a",
						href:reference.url,
						target:"_blank",
						rel: "noopener"
					}
				}
			break;
		}
	}

	return {as:'span'};
}

export const getLinkPropsFromData = (data) => {
	if(data){
		switch(data.link_type){
			case 'Document':
				if(data.lang && data.type){
					return getLinkPropsFromMeta(data)
				}
			break;
			case 'Web':
			case 'Image':
			case 'Media':
				if(data.url){
					return {
						as:"a",
						href:data.url,
						target:"_blank",
						rel: "noopener"
					}
				}
			break;
		}
	}

	return {as:'span'};
}

export const getEmail = (address) => {
	return `mailto:${address}`;
}

export const getPhone = (phone) => {
	return `tel:${phone.replace(/\s+/g, '')}`;
}

export const getProductPath = (lang,uid) => {
	const shortCode = lang.split('-')[0];
	return `/${lang}/products/${uid}/`
}

export const getComplexPath = (lang,uid) => {
	const shortCode = lang.split('-')[0];
	return `/${lang}/${uid}/`
}

export const getHomePath = (lang) => {
	const shortCode = lang.split('-')[0];
	return `/${lang}/`
}

export const getContactPath = (lang) => {
	const shortCode = lang.split('-')[0];
	return `/${lang}/contact/`
}

export const getRulesPath = (lang) => {
	const shortCode = lang.split('-')[0];
	return `/${lang}/rules/`
}

export const getArticlePath = (lang,uid) => {
	const shortCode = lang.split('-')[0];
	return `/${lang}/blog/article/${uid}/`
}

export const getBlogPath = (lang) => {
	const shortCode = lang.split('-')[0];
	return `/${lang}/blog/`
}

export const getBlogPaginationPath = (lang,page) => {
	const shortCode = lang.split('-')[0];
	return `/${lang}/blog/${page && page > 1 ? `${page}/` : ``}`;
}

export const getCategoryPath = (lang,uid) => {
	const shortCode = lang.split('-')[0];
	return `/${lang}/blog/category/${uid}/`
}

export const getCategoryPaginationPath = (lang,uid,page) => {
	const shortCode = lang.split('-')[0];
	return `/${lang}/blog/category/${uid}/${page && page > 1 ? `${page}/` : ``}`
}

export const getLegalPath = (lang,uid) => {
	const shortCode = lang.split('-')[0];
	return `/${lang}/legal/${uid}/`
}

export const getSimplePath = (lang,uid) => {
	const shortCode = lang.split('-')[0];
	return `/${lang}/${uid}/`
}

export const getSearchPath = (lang) => {
	const shortCode = lang.split('-')[0];
	return `/${lang}/blog/search/`
}

export const getFormPath = (lang,uid) => {
	const shortCode = lang.split('-')[0];
	return `/${lang}/form/${uid}/`
}

export const getPathFromMeta = (meta,page=null) => {
	if(meta && meta.type){
		switch(meta.type){
			case 'product': return getProductPath(meta.lang,meta.uid);
			case 'complex': return getComplexPath(meta.lang,meta.uid);
			case 'article': return getArticlePath(meta.lang,meta.uid);
			case 'category': return page ? getCategoryPaginationPath(meta.lang,meta.uid,page) : getCategoryPath(meta.lang,meta.uid);
			case 'blog': return page ? getBlogPaginationPath(meta.lang,page) : getBlogPath(meta.lang);
			case 'home': return getHomePath(meta.lang);
			case 'contact': return getContactPath(meta.lang);
			case 'rules': return getRulesPath(meta.lang);
			case 'legal': return getLegalPath(meta.lang,meta.uid);
			case 'simple': return getSimplePath(meta.lang,meta.uid);
			case 'search': return getSearchPath(meta.lang);
			case 'form': return getFormPath(meta.lang,meta.uid);
		}
	}
	
	if(meta && meta.lang){
		return getHomePath(meta.lang);
	}

	// Backup for all other types
	return '/'
}

export const getAlternateLanguagePaths = (alternates) => {
	if(alternates && alternates.length > 0){
		return alternates.map(alternate => ({
			language: alternate.lang,
			path: getPathFromMeta(alternate)
		}))
	}
	return []
}

export const linkResolver = (meta) => {
	return getPathFromMeta(meta)
}